import React, { useState, useEffect, useRef, useCallback } from "react";
import WaveSurfer from "wavesurfer";
// import ReactWaves from "@dschoon/react-waves";
import BookDataService from "../../../../services/BookService";
import { MdPlayArrow, MdPause } from "react-icons/md";

import "./WsComponent.css";

function WsComponent({
  wsRef,
  source,
  bookID,
  isPlaying,
  setIsPlaying,
  currentTime,
  setCurrentTime,
  playbackRate,
  setPlaybackRate,
}) {
  const [intervalID, setIntervalID] = useState();

  const wsContainer = useRef();

  useEffect(() => {
    wsRef.current = WaveSurfer.create({
      container: wsContainer.current,
      backend: "MediaElement",
      // progressColor: "#4097dd",
      waveColor: "#c6dce9",
      progressColor: "#4677a9",
      normalize: true,
      autoPlay: false,
      removeMediaElementOnDestroy: true,
    });

    wsRef.current.on("ready", () => {
      setIsPlaying(false);
      wsRef.current.stop();
    });

    wsRef.current.on("finish", () => {
      setIsPlaying(false);
      wsRef.current.stop();
    });

    window.addEventListener("resize", handleResize);

    return () => {
      wsRef.current.destroy();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    wsRef.current.load(BookDataService.constructBookAudioLink(bookID, source));
  }, [source]);

  useEffect(() => {
    wsRef.current.setPlaybackRate(playbackRate);
  }, [playbackRate]);

  useEffect(() => {
    if (wsRef.current.isPlaying()) {
      clearInterval(intervalID);
    } else {
      const i = setInterval(updateCurrentTime, 50);
      setIntervalID(i);
    }
    wsRef.current.playPause();
  }, [isPlaying]);

  const updateCurrentTime = useCallback(() => {
    setCurrentTime(wsRef.current.getCurrentTime());
  }, []);

  const handleResize = useCallback(() => {
    wsRef.current.drawer.fireEvent("redraw");
  }, []);

  const convertTime = (time) => {
    let minutes = parseInt(time / 60);
    let seconds = time - minutes * 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds.toFixed(2)}`;
  };

  return (
    <>
      <div className="ws-parent-container">
        <div className="ws-container" ref={wsContainer}>
          <div className="ws-time-label current">{(wsRef.current && convertTime(currentTime)) || "0:00"}</div>
          <div className="ws-time-label duration">{wsRef.current && convertTime(wsRef.current.getDuration())}</div>
        </div>
        <div className="ws-control-panel">
          <button
            className="ws-play-pause-button"
            onClick={() => {
              setIsPlaying((p) => !p);
            }}
          >
            {isPlaying ? <MdPause size="2.5em" fill="#d6ebf7" /> : <MdPlayArrow size="2.5em" fill="#d6ebf7" />}
          </button>
          <div className="playback-rate-main-container">
            <div className="playback-rate-label">
              <div className="label-bracket" />
              <strong>Playback rate</strong>
              <div className="label-bracket" />
            </div>
            <div className="ws-playback-rate-button-group">
              <button
                className={`playback-rate-button ${playbackRate === 0.25 ? "active" : ""}`}
                onClick={() => {
                  setPlaybackRate(0.25);
                }}
              >
                0.25
              </button>
              <button
                className={`playback-rate-button ${playbackRate === 0.5 ? "active" : ""}`}
                onClick={() => {
                  setPlaybackRate(0.5);
                }}
              >
                0.50
              </button>
              <button
                className={`playback-rate-button ${playbackRate === 0.75 ? "active" : ""}`}
                onClick={() => {
                  setPlaybackRate(0.75);
                }}
              >
                0.75
              </button>
              <button
                className={`playback-rate-button ${playbackRate === 1 ? "active" : ""}`}
                onClick={() => {
                  setPlaybackRate(1);
                }}
              >
                1.00
              </button>
            </div>
            <div className="arrow-skip-helper">
              Use arrow keys to jump <strong>{playbackRate * 0.25}</strong>
              {" seconds"}
              <br />
              {"(with the time assign tool)"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WsComponent;
